exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".list[data-v-3120d6cc]{font-size:1.37rem;list-style-type:circle;margin-left:2.5rem}.list li[data-v-3120d6cc]{list-style:circle}.module-warning[data-v-3120d6cc]{font-size:16px;color:#000}", "", {"version":3,"sources":["F:/myugfront/src/pages/lab.vue"],"names":[],"mappings":"AACA,uBACI,kBAAmB,AACnB,uBAAwB,AACxB,kBAAoB,CACvB,AACD,0BACI,iBAAmB,CACtB,AACD,iCACI,eAAgB,AAChB,UAAY,CACf","file":"lab.vue","sourcesContent":["\n.list[data-v-3120d6cc]  {\n    font-size: 1.37rem;\n    list-style-type: circle;\n    margin-left: 2.5rem;\n}\n.list li[data-v-3120d6cc]{\n    list-style: circle;\n}\n.module-warning[data-v-3120d6cc] {\n    font-size: 16px;\n    color: #000;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-3120d6cc","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/lab.vue
// module id = 1101
// module chunks = 12